// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"225":"ddc3ffaed8fe1c86","1124":"10682bd8ec27e5c1","3790":"606ee963c7a7c291"}[chunkId] + ".css";
};